/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeSingleImageViewProps } from './moe-single-image';

export default (props: IMoeSingleImageViewProps) => {
    const {
        config: { imageSource, className }
    } = props;

    return (
        imageSource && (
            <div className={`moe-image-wrap ${className}`}>
                {/* <Msdyn365.Image
                {...item}
                gridSettings={this.props.context.request.gridSettings!}
                imageSettings={itemImageSettings}
                loadFailureBehavior='default'
                aria-hidden={isAriaHiddenAttribute}
                editProps={{
                    key: this.props.config.thumbnailImage ?? {},
                    requestContext: this.props.context.request,
                    moduleType: this.props.typeName,
                    imagePropertyName: 'image',
                    // eslint-disable-next-line max-len -- Auto-suppressed.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment -- Auto-suppressed.
                    layout: (this.props.config as any).msdyn365__moduleLayout
                }}
            /> */}
                <img tabIndex={0} className='moe-image' src={imageSource.src} alt={imageSource.altText || ' '} />
            </div>
        )
    );
};
